// @flow
import fp from "lodash/fp"

// Check if newPrice is in intervals:
// [95 % of oldPrice ... 105 % of oldPrice )
// AND
// [oldPrice - 0.5 ... oldPrice + 0.5 )
//
// intervals are closed from left, open from right
// so left bound in included, right excluded
const isAcceptedDeviation = (newPrice: number, oldPrice: number) =>
  fp.inRange(oldPrice * 0.95, oldPrice * 1.05, newPrice) &&
  fp.inRange(oldPrice - 0.5, oldPrice + 0.5, newPrice)

export default isAcceptedDeviation
